import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
declare var $: any;
@Component({
  selector: 'app-edit-animal-disease',
  templateUrl: './edit-animal-disease.component.html',
  styleUrls: ['./edit-animal-disease.component.css']
})
export class EditAnimalDiseaseComponent implements OnInit {
  getdiseaseeditApi:any;
  putdiseaseeditApi:any;
  EditDiseaseFormValue:any;
  addUrl:any;
  getlistApi:any;
  getDiseaseListData:any;
  loginresponse:any;
  cby_mby:any;
  returnUrl="/dashboard/RottweilerDogsAnimalmanagement"
  constructor(private router: Router,private commonService:CommonService) { }

 async ngOnInit() {
  this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
  this.cby_mby=this.loginresponse.user_id;
  $('.selectpicker').selectpicker('refresh'); 
    let DiseaseId = sessionStorage.getItem('diseaseId');
    this.getdiseaseeditApi= "/animal_management/disease/"+ DiseaseId;
    this.putdiseaseeditApi= "/animal_management/disease/"+ DiseaseId;
    (await this.commonService.getApi(this.getdiseaseeditApi)). subscribe(
      async  (res:any) => {
        this.getlistApi= "/disease";
        (await this.commonService.getApi(this.getlistApi)).subscribe(
          async (res) => {
            this.getDiseaseListData = res.data;
          })
         var date=res.data.tnam_dis_date_of_discovery;
         var testdate = date.split('T');
         $("#dosevalue").val(res.data.tnam_dis_dose_value)
         $("#unit").val(res.data.tnam_dis_units)
         $("#drugname").val(res.data.tnam_dis_drug_name)
        $("#DiscoveryDate").val(testdate[0])       
         $("#DiseaseName").val(res.data.tnam_dis_disease_name)
         $("#Treatment").val(res.data.tnam_dis_treatment_given)
         $("#Description").val(res.data.tnam_dis_disease_description)

  
        })
  }
  
  async AnimalDisease(){
    var farmid=sessionStorage.getItem('farmid');
    var Animalid=sessionStorage.getItem('animalid');
    var speciesid=sessionStorage.getItem('speciesid');
    var breedid=sessionStorage.getItem('breedid');
    var ageid=sessionStorage.getItem('ageid');
    this.EditDiseaseFormValue = {
      "species_id":speciesid,
       "breed_id": breedid,
       "farm_id":farmid,
       "animal_code":Animalid,
       "disease_name":$("#DiseaseName").val(),
       "drug_name":$("#drugname").val(),
       "dose_value":$("#dosevalue").val(),
       "units":$("#unit").val(),
       "treatment_given":$("#Treatment").val(),
       "age_group":ageid,
       "disease_description":$("#Description").val(),
       "date_of_discovery":$("#DiscoveryDate").val(),
       "cby":this.cby_mby,
       "mby":this.cby_mby,
       "status": 1,
       "is_active": 1
     };
    
       (await this.commonService.putApi(this.putdiseaseeditApi,this.EditDiseaseFormValue)).subscribe(
         data => {
             alert("Data edited successfully");
         });
         setTimeout(
          () : void => {
    
            this.router.navigate([this.returnUrl]);
    
          },
          500
        );
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
